import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiButtonDirective } from './button.directive';
import { MatButtonModule } from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule
  ],
  declarations: [AiButtonDirective],
  exports: [AiButtonDirective, MatButtonModule]
})
export class AiButtonModule { }
